import { AbstractFreewheelRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/AbstractFreewheelRequestFactory';
import { FreewheelDaiApiRequest } from 'tag/ts/tag/ads/freewheel/requests/FreewheelDaiApiRequest';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Used to create Freewheel DAI API request
 */
export class FreewheelDaiApiRequestFactory extends AbstractFreewheelRequestFactory {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'FreewheelDaiApiRequestFactory'
			}
		);
	}

	/**
	 * @description Creates and returns a FreewheelDaiApiRequest instance
	 * @return {FreewheelDaiApiRequest}
	 */
	createRequest(): FreewheelDaiApiRequest {
		const request = new FreewheelDaiApiRequest( { tag: this.tag } );
		this?.logger?.log( 'createRequest', 'returning FreewheelDaiApiRequest:', request );
		return request;
	}
}